import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const CardCheckStyle = styled.div`
  &:focus {
    outline: none;
  }
  .MuiFormControlLabel-root {
    display: flex;
    padding: 16px;
    border: 1px solid ${theme.divider_and_border.input_border};
    width: 100%;
    border-radius: 6px;
  }
  &.active {
    .MuiFormControlLabel-root {
      background: ${(props) => props.theme.primary.primary10};
      border: 1px solid ${(props) => props.theme.primary.primary50};
    }
  }
  .MuiTypography-root {
    padding-left: 5px;
    line-height: 22px;
  }
`;
